export interface BankingInfo {
  name: string;
  pixKeyType: PixKeyType;
  pixKey: string;
  document: string;
  bankCode?: string;
  agency?: string;
  agencyDigit?: string;
  accountType?: AccountType;
  account?: string;
  accountDigit?: string;
}

export enum PixKeyType {
  RANDOM_KEY = 'RANDOM_KEY',
  DOCUMENT = 'DOCUMENT',
  PHONE = 'PHONE',
  MAIL = 'MAIL',
}

export enum AccountType {
  CHECKING = 'CHECKING',
  SAVINGS = 'SAVINGS',
}
